import type { PropsWithChildren } from 'react';

import * as Styled from './OTError.styled';

type OTErrorProps = {
  title: string;
  description: string | null;
  retryLabel?: string;
  onRetry?: () => void;
  pendoId?: string;
} & PropsWithChildren;

export default function OTError({
  title,
  description,
  retryLabel = 'Retry',
  onRetry,
  children,
  pendoId,
}: OTErrorProps) {
  return (
    <Styled.Wrapper>
      <Styled.BackgroundImage
        alt="Error background"
        src="/assets/opentable/images/error.png"
      />
      <Styled.Content>
        <Styled.Title>{title}</Styled.Title>
        {description && <Styled.Description>{description}</Styled.Description>}
        {onRetry && (
          <Styled.RetryButton data-pendo-id={pendoId} onClick={onRetry}>
            {retryLabel}
          </Styled.RetryButton>
        )}
        {children}
      </Styled.Content>
    </Styled.Wrapper>
  );
}
